import { usePostMutation } from "@/api/swr/useMutation";
import { answerContentCreateSchema } from "@/schema/console/checking-assessments/AnswerContent";
import { z } from "zod";

type Config = Parameters<
  typeof usePostMutation<typeof answerContentCreateSchema, z.ZodNull>
>[3];

export const useSaveChanges = (id: string, config?: Config) => {
  return usePostMutation(
    answerContentCreateSchema,
    z.null(),
    `/console/re_assessments/answer_sub_categories/${id}/save_changes`,
    config,
  );
};
